// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toaster":"toaster-JCLgI","toast":"toast-2TzfX","close":"close-1iSZp","icon":"icon-21ybq"};